var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "237.121px",
    height: "236.211px",
    viewBox: "0 0 237.121 236.211",
    enableBackground: "new 0 0 237.121 236.211",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1245",
    transform: "matrix(3.3139255,0,0,3.3139255,-50.282703,-30.374932)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g1247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1253",
    transform: "translate(87.8938,38.5279)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1257",
    transform: "translate(93.6268,40.9098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path947",
    fill: "#231F20",
    d: "M-77.101,0.346v3.951c0,0.462,0.068,0.882,0.214,1.148 c0.386,0.711,1.011,0.78,1.311,0.78c0.3,0,0.926-0.069,1.311-0.78c0.146-0.266,0.215-0.686,0.215-1.148V0.346h0.634v3.951 c0,0.531-0.086,0.985-0.24,1.319c-0.437,0.951-1.329,1.182-1.92,1.182c-0.591,0-1.482-0.231-1.919-1.182 c-0.154-0.334-0.24-0.788-0.24-1.319V0.346H-77.101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path949",
    fill: "#231F20",
    d: "M-72.535,6.688h0.635V5.959h-0.635V6.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path951",
    fill: "#231F20",
    d: "M-67.205,6.688h0.635V5.959h-0.635V6.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path963",
    fill: "#231F20",
    d: "M-70.767,5.393c0.18,0.518,0.622,0.832,1.232,0.832 c0.668,0,1.276-0.514,1.276-1.26c0-0.976-0.985-1.225-1.414-1.354c-0.574-0.171-1.645-0.411-1.645-1.67 c0-0.986,0.78-1.705,1.783-1.705c0.692,0,1.243,0.355,1.533,0.867l-0.557,0.292c-0.197-0.352-0.569-0.585-0.976-0.585 c-0.729,0-1.149,0.556-1.149,1.105c0,0.771,0.677,0.951,1.508,1.191c1.56,0.42,1.551,1.645,1.551,1.834 c0,0.976-0.788,1.859-1.91,1.859c-0.664,0-1.512-0.318-1.828-1.174L-70.767,5.393z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path967",
    fill: "#231F20",
    d: "M-64.662,0.346h1.703c0.717,0,1.426,0.189,1.899,0.523 c1.026,0.694,1.325,1.902,1.325,2.665c0,0.591-0.213,1.859-1.325,2.631c-0.473,0.333-1.182,0.522-1.899,0.522h-1.703V0.346z  M-64.079,6.113h0.844c0.528,0,1.332,0,2.002-0.515c0.355-0.325,0.915-0.985,0.915-2.09c0-0.84-0.387-1.62-0.994-2.099 c-0.52-0.369-1.064-0.489-1.923-0.489h-0.844V6.113z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path971",
    fill: "#231F20",
    d: "M-58.856,4.562c0.04,0.917,0.844,1.697,1.704,1.697 c0.758-0.017,1.309-0.467,1.538-1.006l0.51,0.206c-0.374,0.779-1.14,1.339-2.04,1.339c-1.23,0-2.292-1.062-2.292-2.45 c0-1.328,1.006-2.443,2.284-2.468c0.965,0.008,1.649,0.617,1.962,1.2c0.298,0.505,0.362,1.028,0.339,1.482H-58.856z  M-55.422,4.022c-0.177-1.105-1.021-1.602-1.721-1.602c-0.691,0-1.552,0.497-1.712,1.602H-55.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path975",
    fill: "#231F20",
    d: "M-30.668,4.562c0.04,0.917,0.844,1.697,1.704,1.697 c0.758-0.017,1.309-0.467,1.538-1.006l0.511,0.206c-0.375,0.779-1.141,1.339-2.041,1.339c-1.23,0-2.292-1.062-2.292-2.45 c0-1.328,1.006-2.443,2.284-2.468c0.965,0.008,1.649,0.617,1.962,1.2c0.298,0.505,0.362,1.028,0.339,1.482H-30.668z  M-27.235,4.022c-0.177-1.105-1.021-1.602-1.721-1.602c-0.691,0-1.552,0.497-1.712,1.602H-27.235z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path979",
    fill: "#231F20",
    d: "M-54.284,2h0.582v0.823h0.016 c0.524-0.772,1.28-0.943,1.771-0.943c1.488,0,2.443,1.2,2.443,2.451c0,1.345-1.014,2.467-2.443,2.467 c-0.474,0-1.264-0.171-1.771-0.933h-0.016v2.468h-0.582V2z M-51.915,2.42c-1.048,0-1.821,0.9-1.821,1.928 c0,1.097,0.84,1.911,1.821,1.911c1.114,0,1.862-0.857,1.862-1.903C-50.053,3.165-50.918,2.42-51.915,2.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path983",
    fill: "#231F20",
    d: "M-49.616,11.381h0.582v0.822h0.016 c0.524-0.771,1.28-0.942,1.771-0.942c1.488,0,2.443,1.199,2.443,2.451c0,1.345-1.014,2.467-2.443,2.467 c-0.474,0-1.264-0.171-1.771-0.933h-0.016v2.467h-0.582V11.381z M-47.247,11.801c-1.048,0-1.821,0.899-1.821,1.928 c0,1.097,0.84,1.911,1.821,1.911c1.114,0,1.862-0.858,1.862-1.903C-45.385,12.546-46.25,11.801-47.247,11.801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path987",
    fill: "#231F20",
    d: "M-44.28,6.688h-0.588V5.865h-0.017 c-0.503,0.77-1.309,0.933-1.788,0.933c-1.444,0-2.469-1.122-2.469-2.467c0-1.251,0.966-2.451,2.469-2.451 c0.495,0,1.302,0.163,1.788,0.942h0.017V2.001h0.588V6.688z M-46.673,6.259c0.991,0,1.839-0.814,1.839-1.911 c0-1.028-0.781-1.928-1.839-1.928c-1.008,0-1.881,0.745-1.881,1.936C-48.555,5.402-47.799,6.259-46.673,6.259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path991",
    fill: "#231F20",
    d: "M-43.477,2h0.6v0.677h0.017 c0.283-0.66,0.814-0.763,1.319-0.797v0.634c-0.419,0.034-0.779,0.189-1.011,0.463c-0.205,0.257-0.325,0.591-0.325,0.968v2.742 h-0.6V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path995",
    fill: "#231F20",
    d: "M-38.719,11.381h0.6v0.677h0.017 c0.283-0.66,0.814-0.762,1.319-0.797v0.634c-0.419,0.034-0.779,0.189-1.011,0.463c-0.205,0.257-0.325,0.592-0.325,0.968v2.743 h-0.6V11.381z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path999",
    fill: "#231F20",
    d: "M-40.273,2.54h-0.832V2h0.832V0.86h0.6V2h0.917v0.54 h-0.917v4.148h-0.6V2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1003",
    fill: "#231F20",
    d: "M-20.973,2.54h-0.831V2h0.831V0.86h0.599V2h0.918 v0.54h-0.918v4.148h-0.599V2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1007",
    fill: "#231F20",
    d: "M-27.84,11.921h-0.832v-0.54h0.832V10.24h0.6v1.141 h0.917v0.54h-0.917v4.148h-0.6V11.921z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    fill: "#231F20",
    d: "M-35.425,11.921h-0.831v-0.54h0.831V10.24h0.6v1.141 h0.917v0.54h-0.917v4.148h-0.6V11.921z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    fill: "#231F20",
    d: "M-37.523,2.54c0.25-0.463,0.789-0.66,1.2-0.66 c0.369,0,1.153,0.18,1.483,0.9c0.329-0.72,1.111-0.9,1.482-0.9c0.676,0,1.763,0.429,1.763,2.022v2.786h-0.564V3.971 c0-0.514-0.088-0.762-0.201-0.977c-0.185-0.334-0.523-0.574-0.998-0.574c-0.475,0-0.814,0.24-1,0.574 c-0.112,0.215-0.2,0.463-0.2,0.977v2.717h-0.565V3.971c0-0.514-0.088-0.762-0.201-0.977c-0.185-0.334-0.523-0.574-0.999-0.574 c-0.475,0-0.814,0.24-0.999,0.574c-0.113,0.215-0.201,0.463-0.201,0.977v2.717h-0.564V2h0.564V2.54z M-37.539,2.523V2.54 h0.017L-37.539,2.523z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    fill: "#231F20",
    d: "M-25.956,2h0.576v0.6h0.016 c0.173-0.283,0.617-0.72,1.382-0.72c0.552,0,1.012,0.146,1.423,0.574C-22.222,2.797-22,3.337-22,4.108v2.579h-0.575V4.108 c0-0.608-0.181-1.037-0.428-1.285c-0.313-0.318-0.724-0.403-0.979-0.403c-0.255,0-0.667,0.085-0.979,0.403 c-0.246,0.248-0.427,0.677-0.419,1.285v2.579h-0.576V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1031",
    fill: "#231F20",
    d: "M-57.824,11.381h0.576v0.599h0.016 c0.173-0.282,0.617-0.719,1.382-0.719c0.552,0,1.012,0.146,1.423,0.574c0.338,0.343,0.559,0.883,0.559,1.654v2.58h-0.575 v-2.58c0-0.608-0.181-1.037-0.428-1.285c-0.313-0.318-0.724-0.403-0.979-0.403s-0.667,0.085-0.979,0.403 c-0.246,0.248-0.428,0.677-0.419,1.285v2.58h-0.576V11.381z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1035",
    fill: "#231F20",
    d: "M-18.775,11.381h0.576v0.599h0.016 c0.173-0.282,0.617-0.719,1.382-0.719c0.552,0,1.012,0.146,1.423,0.574c0.338,0.343,0.559,0.883,0.559,1.654v2.58h-0.575 v-2.58c0-0.608-0.181-1.037-0.428-1.285c-0.313-0.318-0.724-0.403-0.979-0.403c-0.255,0-0.667,0.085-0.979,0.403 c-0.246,0.248-0.427,0.677-0.419,1.285v2.58h-0.576V11.381z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1039",
    fill: "#231F20",
    d: "M-75.339,11.19c1.388,0,2.459,1.174,2.459,2.459 c0,1.277-1.054,2.459-2.459,2.459c-1.371,0-2.442-1.156-2.442-2.424C-77.781,12.201-76.573,11.19-75.339,11.19  M-75.331,15.569c0.909,0,1.851-0.72,1.851-1.945c0-1.234-1.045-1.894-1.851-1.894c-0.857,0-1.85,0.702-1.85,1.945 C-77.181,14.763-76.299,15.569-75.331,15.569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    fill: "#231F20",
    d: "M-72.069,11.955h-0.728v-0.539h0.728 c0.016-0.62,0.064-1.646,1.564-1.757l-0.012,0.566c-1.004,0.085-0.952,0.781-0.952,1.191h0.857v0.539h-0.857v4.148h-0.6 V11.955z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1047",
    fill: "#231F20",
    d: "M-67.025,10.322h-1.457V9.748h3.539v0.574h-1.448 v5.767h-0.634V10.322z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    fill: "#231F20",
    d: "M-65.286,11.387h0.6v0.676h0.017 c0.283-0.659,0.814-0.762,1.32-0.796v0.633c-0.42,0.035-0.78,0.189-1.012,0.464c-0.205,0.257-0.325,0.591-0.325,0.968v2.742 h-0.6V11.387z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1063",
    fill: "#231F20",
    d: "M-52.543,15.024c0.15,0.551,0.611,0.599,0.792,0.599 c0.566,0,0.874-0.334,0.874-0.839c0-0.643-0.582-0.789-0.934-0.935c-0.48-0.162-1.242-0.42-1.242-1.302 c0-0.66,0.471-1.302,1.337-1.302c0.526,0,0.986,0.303,1.179,0.766l-0.534,0.314c-0.108-0.416-0.439-0.54-0.671-0.54 c-0.48,0-0.712,0.385-0.712,0.702c0,0.497,0.498,0.669,0.84,0.78c0.549,0.18,1.337,0.48,1.337,1.448 c0.009,0.806-0.48,1.448-1.474,1.448c-0.521,0-1.147-0.285-1.363-0.941L-52.543,15.024z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1067",
    fill: "#231F20",
    d: "M-29.146,16.096h-0.577v-0.822h-0.016 c-0.493,0.77-1.283,0.933-1.752,0.933c-1.415,0-2.419-1.122-2.419-2.468c0-1.25,0.947-2.45,2.419-2.45 c0.486,0,1.275,0.163,1.752,0.942h0.016v-0.822h0.577V16.096z M-31.492,15.668c0.971,0,1.802-0.814,1.802-1.911 c0-1.029-0.765-1.928-1.802-1.928c-0.987,0-1.843,0.746-1.843,1.936C-33.335,14.81-32.595,15.668-31.492,15.668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1071",
    fill: "#231F20",
    d: "M-58.605,16.065h-0.577v-0.822h-0.016 c-0.493,0.77-1.283,0.933-1.752,0.933c-1.415,0-2.419-1.122-2.419-2.468c0-1.25,0.947-2.45,2.419-2.45 c0.486,0,1.275,0.163,1.752,0.942h0.016v-0.822h0.577V16.065z M-60.95,15.637c0.971,0,1.802-0.814,1.802-1.911 c0-1.029-0.765-1.928-1.802-1.928c-0.987,0-1.843,0.746-1.843,1.936C-62.793,14.779-62.053,15.637-60.95,15.637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1073",
    fill: "#231F20",
    d: "M-25.622,10.431h0.6v-0.63h-0.6V10.431z  M-25.622,16.141h0.6v-4.687h-0.6V16.141z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1085",
    fill: "#231F20",
    d: "M-21.857,11.244c1.388,0,2.459,1.174,2.459,2.459 c0,1.277-1.053,2.459-2.459,2.459c-1.371,0-2.442-1.156-2.442-2.424C-24.299,12.255-23.091,11.244-21.857,11.244  M-21.848,15.623c0.909,0,1.851-0.72,1.851-1.945c0-1.234-1.046-1.894-1.851-1.894c-0.857,0-1.851,0.702-1.851,1.945 C-23.699,14.817-22.816,15.623-21.848,15.623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    fill: "#231F20",
    d: "M-41.786,11.244c1.388,0,2.459,1.174,2.459,2.459 c0,1.277-1.053,2.459-2.459,2.459c-1.371,0-2.442-1.156-2.442-2.424C-44.228,12.255-43.02,11.244-41.786,11.244  M-41.777,15.623c0.908,0,1.851-0.72,1.851-1.945c0-1.234-1.046-1.894-1.851-1.894c-0.857,0-1.851,0.702-1.851,1.945 C-43.628,14.817-42.745,15.623-41.777,15.623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1105",
    fill: "#231F20",
    d: "M-77.391,23.61h3.377v1.096h-2.203v1.551h2.108v1.097 h-2.108v2.597h-1.174V23.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    fill: "#231F20",
    d: "M-72.321,28.082c0.05,0.309,0.482,0.978,1.272,0.978 c0.49,0,0.942-0.301,1.149-0.695l0.901,0.56c-0.4,0.626-1.196,1.18-2.05,1.18c-1.405,0-2.436-1.131-2.436-2.52 c0-1.345,0.964-2.554,2.427-2.554c1.513,0,2.386,1.278,2.386,2.477c0,0.223-0.034,0.42-0.067,0.574H-72.321z M-69.802,27.165 c-0.125-0.762-0.657-1.088-1.247-1.088c-0.449,0-1.097,0.206-1.305,1.088H-69.802z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    fill: "#231F20",
    d: "M-61.415,28.082c0.05,0.309,0.482,0.978,1.272,0.978 c0.49,0,0.942-0.301,1.149-0.695l0.901,0.56c-0.4,0.626-1.196,1.18-2.05,1.18c-1.405,0-2.436-1.131-2.436-2.52 c0-1.345,0.964-2.554,2.427-2.554c1.513,0,2.386,1.278,2.386,2.477c0,0.223-0.034,0.42-0.067,0.574H-61.415z M-58.896,27.165 c-0.125-0.762-0.657-1.088-1.247-1.088c-0.449,0-1.097,0.206-1.305,1.088H-58.896z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    fill: "#231F20",
    d: "M-63.362,29.95h-1.045v-0.583h-0.017 c-0.215,0.343-0.712,0.737-1.517,0.737c-1.208,0-2.425-0.994-2.425-2.528c0-1.602,1.285-2.545,2.425-2.545 c0.694,0,1.105,0.232,1.439,0.583v-2.005h1.14V29.95z M-65.821,29.059c0.857,0,1.405-0.771,1.405-1.491 c0-0.78-0.599-1.491-1.405-1.491c-0.848,0-1.406,0.788-1.406,1.457C-67.227,28.416-66.567,29.059-65.821,29.059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1129",
    fill: "#231F20",
    d: "M-49.182,29.95h-1.046v-0.591 c-0.359,0.428-1.062,0.745-1.662,0.745c-1.225,0-2.314-0.976-2.314-2.562c0-1.457,1.063-2.511,2.383-2.511 c0.968,0,1.542,0.695,1.576,0.763h0.017v-0.599h1.046V29.95z M-51.65,26.077c-0.934,0-1.414,0.806-1.414,1.516 c0,0.806,0.6,1.466,1.414,1.466c0.788,0,1.388-0.617,1.388-1.5C-50.262,26.574-50.973,26.077-51.65,26.077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    fill: "#231F20",
    d: "M-48.317,23.609h1.14v6.341h-1.14V23.609z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1177",
    fill: "#231F20",
    d: "M-75.052,33.039h0.917l2.656,6.341h-1.293 l-0.678-1.637h-2.27l-0.677,1.637h-1.294L-75.052,33.039z M-75.326,36.638h1.457l-0.72-1.945h-0.017L-75.326,36.638z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1189",
    fill: "#231F20",
    d: "M-66.358,39.38h-1.046v-0.583h-0.017 c-0.214,0.343-0.711,0.737-1.516,0.737c-1.209,0-2.426-0.994-2.426-2.528c0-1.602,1.286-2.545,2.426-2.545 c0.694,0,1.105,0.232,1.439,0.583v-2.005h1.14V39.38z M-68.817,38.488c0.857,0,1.405-0.771,1.405-1.491 c0-0.78-0.6-1.491-1.405-1.491c-0.849,0-1.406,0.788-1.406,1.457C-70.223,37.845-69.563,38.488-68.817,38.488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1193",
    fill: "#231F20",
    d: "M-65.536,34.624h1.046v0.402h0.017 c0.094-0.154,0.42-0.566,1.242-0.566c0.257,0,0.926,0.061,1.371,0.746c0.497-0.711,1.2-0.746,1.534-0.746 c0.934,0,1.397,0.498,1.568,0.738c0.189,0.248,0.36,0.703,0.36,1.405v2.776h-1.14V36.74c0-0.274,0-1.234-0.9-1.234 c-0.316,0-0.625,0.172-0.788,0.445c-0.18,0.284-0.171,0.755-0.171,1.055v2.373h-1.14V36.74c0-0.651-0.248-1.234-0.951-1.234 c-0.908,0-0.908,0.994-0.908,1.5v2.373h-1.14V34.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1195",
    fill: "#231F20",
    d: "M-57.49,33.039h1.14v1.045h-1.14V33.039z  M-57.49,34.624h1.14v4.755h-1.14V34.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1207",
    fill: "#231F20",
    d: "M-55.268,34.624h1.054v0.411 c0.188-0.18,0.583-0.575,1.302-0.575c0.412,0,1.037,0.181,1.431,0.661c0.437,0.522,0.437,1.319,0.437,1.688v2.57h-1.139 v-2.347c0-0.394,0-1.526-0.96-1.526c-0.206,0-0.574,0.103-0.78,0.42c-0.205,0.292-0.205,0.789-0.205,1.191v2.262h-1.14V34.624 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1209",
    fill: "#231F20",
    d: "M-50.096,33.039h1.14v1.045h-1.14V33.039z  M-50.096,34.624h1.14v4.755h-1.14V34.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1221",
    fill: "#231F20",
    d: "M-45.908,35.752c-0.107-0.222-0.3-0.246-0.4-0.246 c-0.282,0-0.437,0.214-0.437,0.411c0,0.275,0.197,0.335,0.806,0.532c0.591,0.179,1.328,0.462,1.328,1.422 c0,1.072-0.849,1.663-1.663,1.663c-0.471,0-1.054-0.163-1.422-0.626c-0.104-0.13-0.177-0.261-0.228-0.39l1.056-0.551 c0.06,0.219,0.191,0.521,0.603,0.521c0.368,0,0.514-0.283,0.514-0.48c0-0.351-0.257-0.437-1.071-0.711 c-0.54-0.18-1.062-0.583-1.062-1.362c0-0.926,0.831-1.475,1.593-1.475c0.509,0,1.061,0.263,1.35,0.757L-45.908,35.752z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    fill: "#231F20",
    d: "M-40.494,34.624h1.045v0.419h0.017 c0.215-0.308,0.429-0.583,1.02-0.583l0.418,0.052l-0.244,1.055c-1.116,0.042-1.116,0.856-1.116,1.139v2.673h-1.14V34.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    fill: "#231F20",
    d: "M-57.113,25.171h1.045v0.419h0.017 c0.215-0.308,0.429-0.583,1.02-0.583l0.418,0.052l-0.244,1.055c-1.116,0.042-1.116,0.856-1.116,1.139v2.673h-1.14V25.171z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1233",
    fill: "#231F20",
    d: "M-32.645,39.38h-1.045v-0.591 c-0.36,0.428-1.063,0.745-1.663,0.745c-1.225,0-2.313-0.976-2.313-2.562c0-1.457,1.062-2.511,2.381-2.511 c0.969,0,1.543,0.695,1.577,0.763h0.018v-0.599h1.045V39.38z M-35.113,35.507c-0.934,0-1.414,0.806-1.414,1.516 c0,0.806,0.6,1.466,1.414,1.466c0.788,0,1.388-0.617,1.388-1.5C-33.725,36.003-34.436,35.507-35.113,35.507"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1237",
    fill: "#231F20",
    d: "M-31.216,35.635h-0.557v-1.011h0.557V33.17h1.14 v1.454h0.685v1.011h-0.685v3.744h-1.14V35.635z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1241",
    fill: "#231F20",
    d: "M-43.412,35.635h-0.557v-1.011h0.557V33.17h1.14 v1.454h0.685v1.011h-0.685v3.744h-1.14V35.635z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1243",
    fill: "#231F20",
    d: "M-28.508,33.039h1.14v1.045h-1.14V33.039z  M-28.508,34.624h1.14v4.755h-1.14V34.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1255",
    fill: "#231F20",
    d: "M-26.56,37.006c0-1.439,1.174-2.545,2.536-2.545 c1.346,0,2.52,1.071,2.52,2.528c0,1.559-1.2,2.545-2.52,2.545C-25.437,39.534-26.56,38.369-26.56,37.006 M-22.644,37.014 c0-0.865-0.668-1.507-1.38-1.507c-0.591,0-1.396,0.505-1.396,1.499c0,0.9,0.677,1.483,1.396,1.483 C-23.192,38.489-22.644,37.768-22.644,37.014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1259",
    fill: "#231F20",
    d: "M-20.827,34.624h1.054v0.411 c0.188-0.18,0.582-0.575,1.302-0.575c0.412,0,1.037,0.181,1.431,0.661c0.437,0.522,0.437,1.319,0.437,1.688v2.57h-1.139 v-2.347c0-0.394,0-1.526-0.96-1.526c-0.206,0-0.574,0.103-0.78,0.42c-0.205,0.292-0.205,0.789-0.205,1.191v2.262h-1.14V34.624 z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g2401",
    transform: "matrix(2.4854441,0,0,-2.4854441,-1272.6334,1187.8189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "matrix(2.6194985,0,0,2.6194985,117.30624,42.306099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g110"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    transform: "matrix(2.6194985,0,0,2.6194985,117.30624,42.306099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g182",
    transform: "matrix(1.066108,0,0,1.066108,486.62662,277.98258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g184",
    transform: "matrix(0.34779337,0,0,0.34779337,44.527261,59.469899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path127",
    fill: "#194178",
    d: "M26.707,340.308L26.707,340.308L26.707,340.308 c-6.7,16.4-22.7,27.9-41.5,27.9c-9.5,0-18.2-2.9-25.5-7.9c2.5,0.8,5.3,1.2,8.1,1.2c17.5,0,26.8-10.6,26.8-25.9 c0-1.1-0.1-2.1-0.2-3.1l0,0c-0.2-1.3-0.3-2.7-0.3-4.1c0-8.7,8-16.7,17.6-16.7C23.407,311.709,32.407,327.609,26.707,340.308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164-2",
    fill: "#194178",
    d: "M-50.094,350.909L-50.094,350.909L-50.094,350.909 c-10.8-14-12.8-33.6-3.4-49.8c4.7-8.2,11.7-14.3,19.6-18.1c-1.9,1.8-3.7,4-5.1,6.4c-8.8,15.2-4.2,28.5,9,36.1 c0.9,0.5,1.9,1,2.8,1.4l0,0c1.2,0.5,2.5,1.1,3.7,1.8c7.5,4.3,10.5,15.2,5.6,23.6 C-23.593,362.309-41.893,362.209-50.094,350.909z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    fill: "#194178",
    d: "M-20.893,279.109 C-20.793,279.109-20.793,279.109-20.893,279.109L-20.893,279.109c17.5-2.4,35.5,5.8,44.9,22c4.7,8.2,6.6,17.3,5.8,26 c-0.6-2.6-1.6-5.1-3-7.6c-8.7-15.2-22.5-17.9-35.7-10.2c-0.9,0.5-1.8,1.1-2.6,1.7l0,0c-1.1,0.8-2.2,1.6-3.4,2.3 c-7.5,4.3-18.4,1.4-23.2-6.9C-43.993,296.309-34.693,280.509-20.893,279.109z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g210"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M128.914,196.057c1.332-1.138,2.213-3.381,2.213-5.511c0-2.135-0.82-4.208-2.471-5.571 c-1.137-0.938-2.586-1.537-6.48-1.537h-6.31v21.034h5.146v-6.599h1.499l3.342,6.599h4.874l-4.004-7.123 C127.568,197.049,128.241,196.623,128.914,196.057z M121.012,188.159h1.42c1.163,0,3.55,0,3.55,2.472c0,2.53-2.327,2.53-3.35,2.53 h-1.62V188.159z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1209_4_",
    fill: "#231F20",
    d: "M152.941,183.437h3.784v3.468h-3.784V183.437z  M152.941,188.697h3.784v15.78h-3.784V188.697z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1129_4_",
    fill: "#231F20",
    d: "M214.203,204.457h-3.413v-1.928 c-1.172,1.397-3.466,2.431-5.424,2.431c-3.997,0-7.551-3.185-7.551-8.36c0-4.753,3.469-8.193,7.776-8.193 c3.158,0,5.032,2.268,5.143,2.491h0.056v-1.957h3.413V204.457z M206.15,191.819c-3.048,0-4.614,2.631-4.614,4.947 c0,2.63,1.959,4.784,4.614,4.784c2.571,0,4.529-2.015,4.529-4.895C210.679,193.441,208.359,191.819,206.15,191.819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1189_2_",
    fill: "#231F20",
    d: "M233.574,204.215h-3.429v-1.911h-0.055 c-0.701,1.124-2.33,2.416-4.968,2.416c-3.961,0-7.948-3.258-7.948-8.284c0-5.249,4.214-8.339,7.948-8.339 c2.274,0,3.621,0.761,4.715,1.911v-6.57h3.736V204.215z M225.516,201.294c2.809,0,4.604-2.525,4.604-4.884 c0-2.557-1.966-4.886-4.604-4.886c-2.781,0-4.606,2.581-4.606,4.773C220.909,199.187,223.072,201.294,225.516,201.294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229_2_",
    fill: "#231F20",
    d: "M168.975,188.909h3.423v1.37h0.056 c0.703-1.007,1.405-1.908,3.34-1.908l1.37,0.171l-0.8,3.455c-3.654,0.138-3.654,2.804-3.654,3.729v8.753h-3.734V188.909z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1255_2_",
    fill: "#231F20",
    d: "M178.703,196.651c0-4.729,3.857-8.364,8.334-8.364 c4.425,0,8.282,3.519,8.282,8.308c0,5.125-3.944,8.365-8.282,8.365C182.394,204.96,178.703,201.132,178.703,196.651  M191.573,196.678c0-2.844-2.195-4.952-4.536-4.952c-1.942,0-4.587,1.658-4.587,4.926c0,2.958,2.224,4.874,4.587,4.874 C189.773,201.525,191.573,199.155,191.573,196.678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1129_3_",
    fill: "#231F20",
    d: "M148.93,204.457h-3.413v-1.928 c-1.171,1.397-3.466,2.431-5.424,2.431c-3.997,0-7.55-3.185-7.55-8.36c0-4.753,3.468-8.193,7.776-8.193 c3.157,0,5.031,2.268,5.142,2.491h0.056v-1.957h3.413V204.457z M140.876,191.819c-3.048,0-4.613,2.631-4.613,4.947 c0,2.63,1.958,4.784,4.613,4.784c2.571,0,4.529-2.015,4.529-4.895C145.405,193.441,143.086,191.819,140.876,191.819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1209_3_",
    fill: "#231F20",
    d: "M161.108,183.437h3.783v21.04h-3.783V183.437z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFra);
export default __webpack_public_path__ + "static/media/fra.efb185f07091065d22c0ae92a4bc9e83.svg";
export { ForwardRef as ReactComponent };